import SettingsRepository from './models/repository'
import Setting            from './models/setting'

export default SettingsRepository
export { Setting }
